module.exports = __webpack_public_path__ + "img/formulario.d51f14a5.webp";